// extracted by mini-css-extract-plugin
export var label = "_l8-2";
export var slideContainer = "_l8-0";
export var slider = "_l8-1";